/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
import { getLocalString } from 'pf-core/utilities';
import bubbleChart from 'src/assets/img/mainPageIcons/bubbleChart.svg';
import barChart from 'src/assets/img/mainPageIcons/barChart.svg';
import lineChart from 'src/assets/img/mainPageIcons/lineChart.svg';
import heatMap from 'src/assets/img/mainPageIcons/heatMap.svg';
import radarChart from 'src/assets/img/mainPageIcons/radarChart.svg';
import scatterplotChart from 'src/assets/img/mainPageIcons/scatterplotChart.svg';
import sunburstChart from 'src/assets/img/mainPageIcons/sunburstChart.svg';
import treemapChart from 'src/assets/img/mainPageIcons/treemapChart.svg';
import comboChart from 'src/assets/img/mainPageIcons/comboChart.svg';
import table from 'src/assets/img/mainPageIcons/table.svg';
import map from 'src/assets/img/mainPageIcons/map.svg';
import pieChart from 'src/assets/img/mainPageIcons/pieChart.svg';
import streamChart from 'src/assets/img/mainPageIcons/streamChart.svg';
import calendarChart from 'src/assets/img/mainPageIcons/calendarChart.svg';
import section from 'src/assets/img/sidePanelIcons/section.svg';
import input from 'src/assets/img/sidePanelIcons/input.svg';
import dataGrid from 'src/assets/img/sidePanelIcons/dataGrid.svg';
import textArea from 'src/assets/img/sidePanelIcons/textArea.svg';
import phoneNumber from 'src/assets/img/sidePanelIcons/phoneNumber.svg';
import address from 'src/assets/img/sidePanelIcons/address.svg';
import currency from 'src/assets/img/sidePanelIcons/currency.svg';
import numberRange from 'src/assets/img/sidePanelIcons/numberRange.svg';
import actionDropdown from 'src/assets/img/sidePanelIcons/actionDropdown.svg';
import selectDropdown from 'src/assets/img/sidePanelIcons/selectDropdown.svg';
import advancedSearch from 'src/assets/img/sidePanelIcons/advancedSearch.svg';
import date from 'src/assets/img/sidePanelIcons/date.svg';
import time from 'src/assets/img/sidePanelIcons/time.svg';
import datetime from 'src/assets/img/sidePanelIcons/datetime.svg';
import image from 'src/assets/img/sidePanelIcons/image.svg';
import button from 'src/assets/img/sidePanelIcons/button.svg';
import checkBox from 'src/assets/img/sidePanelIcons/checkBox.svg';
import radio from 'src/assets/img/sidePanelIcons/radio.svg';
import mapSP from 'src/assets/img/sidePanelIcons/mapSP.svg';
import calendar from 'src/assets/img/sidePanelIcons/calendar.svg';
import singleFileUpload from 'src/assets/img/sidePanelIcons/singleFileUpload.svg';
import videoPlayer from 'src/assets/img/sidePanelIcons/videoPlayer.svg';
import mapPlaceHolder from 'src/assets/img/mainPagePlaceholders/map.svg';
import tablePlaceHolder from 'src/assets/img/mainPagePlaceholders/table.svg';
import calendarPlaceholder from 'src/assets/img/mainPagePlaceholders/calendar.svg';
import pieChartPlaceholder from 'src/assets/img/mainPagePlaceholders/pieChart.svg';
import barChartPlaceholder from 'src/assets/img/mainPagePlaceholders/barChart.svg';
import lineChartPlaceholder from 'src/assets/img/mainPagePlaceholders/lineChart.svg';
import comboChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/comboChart.svg';
import bubblePlaceholder from 'src/assets/img/mainPagePlaceholders/bubbleChart.svg';
import radarChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/radarChart.svg';
import scatterplotChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/scatterplotChart.svg';
import sunburstChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/sunburstChart.svg';
import streamChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/streamChart.svg';
import treemapChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/treemapChart.svg';
import heatMapChartPlaceholder from
  'src/assets/img/mainPagePlaceholders/heatMap.svg';
import unknown from 'src/assets/img/mainPagePlaceholders/unknown.svg';

export const BACK_BUTTON = 'Back';
export const CLOSE_BUTTON = 'Close';
export const NOTIFICATION_MIN_COUNT = 0;
export const isDevelopment = (() => {
  return process.env.NODE_ENV === 'development';
})();
export const PRODUCTION = 'production';
export const REDIRECT_URL_COOKIE_KEY = 'redirectURL';
export const DESIGN = 'design';
export const EDITOR = 'editor';
export const PREVIEW = 'Preview';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const WARNING = 'warning';
export const MAIN_PAGE_TYPE = 'MAIN_PAGE';
export const SIDE_PANEL_TYPE = 'SIDE_PANEL';
export const MOBILE_PAGE_TYPE = 'MOBILE_PAGE';
export const COL12 = 12;
export const NUMBER6 = 6;
export const NUMBER16 = 16;
export const SIZE40 = 40;
export const SIZE72 = 72;
export const NUMBER0 = 0;
export const NUMBER1 = 1;
export const MINUS1 = -1;
export const NUMBER40 = 40;
export const NUMBER60 = 60;
export const NUMBER100 = 100;
export const NUMBER180 = 180;
export const NUMBER300 = 300;
export const NUMBER1000 = 1000;
export const NUMBER999 = 999;
export const NUMBER3000 = 3000;
export const NUMBER5000 = 5000;
export const NUMBER10000 = 10000;
export const NUMBER60000 = 60000;
export const NUMBER500 = 500;
export const NUMBER750 = 750;
export const NUMBER8 = 8;
export const NUMBER2 = 2;
export const NUMBER3 = 3;
export const NUMBER4 = 4;
export const NUMBER5 = 5;
export const NUMBER7 = 7;
export const NUMBER9 = 9;
export const NUMBER10 = 10;
export const NUMBER11 = 11;
export const NUMBER12 = 12;
export const NUMBER13 = 13;
export const NUMBER14 = 14;
export const NUMBER15 = 15;
export const NUMBER17 = 17;
export const NUMBER18 = 18;
export const NUMBER20 = 20;
export const NUMBER25 = 25;
export const NUMBER29 = 29;
export const NUMBER30 = 30;
export const OPACITY40 = 0.4;
export const NUMBER19 = 19;
export const NUMBER2000 = 2000;
export const ZOOM125 = 0.125;
export const DEFAULT_BORDER_REM = 0.125;

const ZOOM_VALUE_20 = 0.2;
const ZOOM_VALUE_30 = 0.3;
const ZOOM_VALUE_40 = 0.4;
const ZOOM_VALUE_50 = 0.5;
const ZOOM_VALUE_60 = 0.6;
const ZOOM_VALUE_70 = 0.7;
const ZOOM_VALUE_80 = 0.8;
const ZOOM_VALUE_90 = 0.9;
const ZOOM_VALUE_100 = 1;
const ZOOM_VALUE_110 = 1.1;
const ZOOM_VALUE_120 = 1.2;
const ZOOM_VALUE_130 = 1.3;
const ZOOM_VALUE_140 = 1.4;
const ZOOM_VALUE_150 = 1.5;

export const zoomArr = [
  ZOOM_VALUE_20,
  ZOOM_VALUE_30,
  ZOOM_VALUE_40,
  ZOOM_VALUE_50,
  ZOOM_VALUE_60,
  ZOOM_VALUE_70,
  ZOOM_VALUE_80,
  ZOOM_VALUE_90,
  ZOOM_VALUE_100,
  ZOOM_VALUE_110,
  ZOOM_VALUE_120,
  ZOOM_VALUE_130,
  ZOOM_VALUE_140,
  ZOOM_VALUE_150
];

export const CONFLICT = 'CONFLICT';
export const ROW_HEADER_HT = 43;

export const FIRST_INDEX = 0;
export const NEGATIVE_ONE = -1;
export const SECOND_INDEX = 1;
export const BATCH_SIZE = 50;
export const KEY_CODE_ENTER = 13;
export const MERGE_BRANCH_AND_MASTER = 'MergeBranchandMaster';
export const MERGE_MASTER_AND_BRANCH = 'MergeMasterandBranch';
export const IMPORT_BRANCH = 'Import Branch';
export const IMPORT_MASTER = 'Import Master';
export const INFINITE_SCROLL_MAX_HT = 300;
export const MAX_SIZE_OF_MODEL_FIELD_LENGTH = 255;
export const NAME = 'name';
export const MODEL_STATUS = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  DEPLOYED: 'Deployed',
  PUBLISHED_EDITED: 'PublishedEdited',
  DEPLOYED_EDITED: 'DeployedEdited'
};
export const LENGTH_OF_EMPTY_STRING = 0;
export const panelComponentActionTypes = {
  DELETE: 'delete',
  UPDATE: 'update',
  DUPLICATE: 'duplicate'
};
export const DASH_BOARD = 'DASH_BOARD';
export const NAV_MODULE = 'NAV_MODULE';
export const MODEL_CRUD = 'MODEL_CRUD';
export const MULTI_COLUMN = 'MULTI_COLUMN';
export const CUSTOM_MODULE = 'CUSTOM_MODULE';
export const MODULE_TYPES = {
  DASH_BOARD,
  NAV_MODULE,
  MODEL_CRUD,
  MULTI_COLUMN,
  CUSTOM_MODULE
};
export const isFormViewEnabled = true;
export const tooltipTitle = {
  'jsoneditor-format': 'Beautify',
  'jsoneditor-compact': 'Minify',
  'jsoneditor-sort': 'Sort',
  'jsoneditor-undo': 'Undo',
  'jsoneditor-redo': 'Redo',
  'jsoneditor-expand-all': 'Expand',
  'jsoneditor-collapse-all': 'Collapse'
};
export const MOBILE_PAGE_COMPONENTS = {
  'image': 'Image',
  'input': 'Text Input',
  'dropdown': 'Dropdown',
  'jumbo': 'Jumbotron',
  'divider': 'Divider',
  'collapsibleContentBox': 'Container',
  'textarea': 'Text Area',
  'inputdatetime': 'Date & Time Picker',
  'inputdate': 'Date Picker',
  'inputtime': 'Time Picker',
  'headertext': 'Header/Paragraph',
  'headerhyperlink': 'Hyperlink Header/Paragraph',
  'photocheck': 'Photo Checklist',
  'videoinputcheck': 'Video Checklist',
  'photo': 'Photo',
  'barcode': 'Barcode/QR',
  'signaturecheck': 'Signature Checklist',
  'signature': 'Signature',
  'map': 'Map',
  'geocheckin': 'Geo Check-In',
  'mapaddress': 'Map Address',
  'radio': 'Single Select',
  'checkbox': 'Multiple Select',
  'button': 'Button',
  'buttonIconarrow': 'Button Icon',
  'datagrid': 'Table',
  'document': 'Document',
  'photocomment': 'Photo Comment',
  'videocomment': 'Video Comment',
  'kmzviewer': 'KMZ Viewer',
  'selectitem': 'Add To Table',
  'videoinput': 'Video',
  'integerinput': 'Number Input',
  'decimalinput': 'Decimal Input',
  'multiplecomponent': 'Media Capture',
  'card': 'Step',
  'fileupload': 'File Upload'
};
export const actionTypeList = [
  ['openPanel', 'openPanel'],
  ['closePanel', 'closePanel'],
  ['openModal', 'openModal'],
  ['closeModal', 'closeModal'],
  ['RefreshGridOnSidePanel', 'RefreshGridOnSidePanel'],
  ['refreshDataGrid', 'refreshDataGrid'],
  ['clearPageContext', 'clearPageContext'],
  ['decision', 'decision'],
  ['query', 'query'],
  ['api', 'api'],
  ['script', 'script'],
  ['validatePanel', 'validatePanel'],
  ['showAlert', 'showAlert'],
  ['openOverlayView', 'openOverlayView'],
  ['closeOverlayView', 'closeOverlayView'],
  ['refreshScheduler', 'refreshScheduler'],
  ['refreshSearchDropdown', 'refreshSearchDropdown'],
  ['openModule', 'openModule'],
  ['startWorkflow', 'startWorkflow'],
  ['redirectToPage', 'redirectToPage'],
  ['backPanel', 'backPanel'],
  ['breadcrumbs', 'breadcrumbs'],
  ['setSync', 'setSync'],
  ['fetchUpdatedNotifications', 'fetchUpdatedNotifications'],
  ['createPDF', 'createPDF'],
  ['createCSV', 'createCSV'],
  ['saveDynamicFilter', 'saveDynamicFilter'],
  ['downloadFile', 'downloadFile'],
  ['importDataOnButtonClick', 'importDataOnButtonClick'],
  ['enableUIElement', 'enableUIElement'],
  ['disableUIElement', 'disableUIElement'],
  ['resetUIElement', 'resetUIElement'],
  ['setBranchLabel', 'setBranchLabel'],
  ['getBranchLabel', 'getBranchLabel'],
  ['validateJsonSchema', 'validateJsonSchema'],
  ['handleExportHidden', 'handleExportHidden'],
  ['setExportData', 'setExportData']
];
export const actionTableHeaderSample = [
  {
    'key': 'type',
    'name': 'Action',
    'options': {
      'sortable': true,
      'sortOrder': 'ASC',
      'currentSorted': false,
      'flexValue': 3
    }
  },
  {
    'key': 'name',
    'name': 'Name',
    'options': {
      'sortable': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flexValue': 3
    }
  }
];

export const formViewDataSource = {
    'process/start': 'WORKFLOW',
  'query/read': 'QUERY_ID'
};
export const dataSourceList = [
    ['QUERY_ID', getLocalString('pf_query_id', 'Query ID')],
  ['NEW_QUERY', getLocalString('pf_new_query', 'New Query')],
  ['WORKFLOW', getLocalString('pf_caps_workflow', 'Workflow')]
];
export const tableHeaderSample = [
    {
      'key': 'name',
    'name': getLocalString('pf_display_name', 'Display Name'),
    'primaryKey': true,
    'options': {
        'hidden': false,
      'sortable': true,
      'showLabel': true,
      'searchable': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flexValue': 3
    }
  },
  {
      'key': 'key',
    'name': getLocalString('Key', 'Key'),
    'primaryKey': true,
    'options': {
        'hidden': false,
      'sortable': true,
      'showLabel': true,
      'searchable': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flexValue': 3
    }
  },
  {
      'key': 'displayOrder',
    'name': getLocalString('Display Order', 'Display Order'),
    'primaryKey': true,
    'options': {
        'hidden': false,
      'sortable': true,
      'showLabel': true,
      'searchable': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flexValue': 3
    }
  }
];
export const rowActionTableHeaderSample = [
    {
      'key': 'name',
    'name': getLocalString('name_label', 'Name'),
    'options': {
        'sortable': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flexValue': 3
    }
  },
  {
      'key': 'activeIcon',
    'name': getLocalString('pf_active_icon', 'Active Icon'),
    'options': {
        'sortable': true,
      'sortOrder': 'ASC',
      'currentSorted': false,
      'flexValue': 3
    }
  }
];
export const columnNameHeader = [{
    'key': 'columnName',
  'name': getLocalString('pf_column_names', 'Column Names'),
  'options': {
      'sortable': true,
    'showLabel': true,
    'currentSorted': false,
    'sortOrder': 'ASC'
  }
}];
export const permissions = {
    'Hidden': 'hidden',
  'Sortable': 'sortable',
  'Show Label': 'showLabel',
  'Primary Key': 'primaryKey',
  'Searchable': 'searchable'
};
export const jsonDefPermissions = {
    'Row Deletable': 'deleteAllowed',
  'Scrollable': 'isScrollAble',
  'Searchable': 'searchAllowed',
  'Updatable': 'updateAllowed',
  'Exportable': 'exportable',
  'Export All': 'exportAll',
  'Export Selected': 'exportSelected',
  'Importable': 'importable'
};
export const buttonTypeList = [
    ['primary', 'Primary'],
  ['secondary', 'Secondary'],
  ['buttonIcon', 'Icon Button']
];
export const headerButtonTableHeader = [
    {
      'key': 'title',
    'name': 'Title',
    'options': {
        'sortable': true,
      'sortOrder': 'ASC',
      'currentSorted': true,
      'flexValue': 3
    }
  },
  {
      'key': 'buttonType',
    'name': 'Name',
    'options': {
        'sortable': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flexValue': 3
    }
  }
];
export const layoutErrorMsgDef = {
    NOT_AN_ARRAY: 'layoutConfig should always be an array',
  NEGATIVE_VALUES: 'layoutConfig should not contain negative values',
  WIDTH_HEIGHT_ZERO: 'width and height values should not be 0',
  LENGTH_NOT_EQUAL_TO_FOUR: 'layoutConfig array should always contain 4 values',
  X_GREATER_THAN_12: 'layoutConfig x should not exceed 11',
  MIN_WIDTH: 'width should not be less than 3',
  MIN_HEIGHT: 'height should not be less than 4',
  MAX_WIDTH: 'width should not be more than 12',
  MAX_HEIGHT: 'height should not be more than 16',
  X_WIDTH_GREATER_THAN_TWELVE: 'layoutConfig x+w should not exceed 12'
};
export const zAppUpgradeOmitKeys = [
  'recver', 'mstrecver', 'rmtrecver', '__merged'
];
export const permissionsCheckBoxKeys = ['Row Deletable', 'Scrollable',
  'Searchable', 'Updatable'];
export const importAndExportCheckBoxKeys = ['Exportable', 'Export All',
  'Export Selected', 'Importable'];
export const selectableTypeRadioKeys = ['Single Select', 'Multi Select',
  'No Selection Allowed'];
export const NO_SELECTION_ALLOWED = 'No Selection Allowed';
export const SINGLE_SELECT = 'Single Select';
export const MULTI_SELECT = 'Multi Select';
export const modelQuery = {
  'dataSourceId': 'query/read',
  'sourceType': 'query',
  'dataToBeSent': {
    queryId: 'constants_modelQuery_ModelHeader'
  }
};
export const dataType = ['int', 'string', 'date', 'boolean',
  'double', 'long', 'float'];
export const fetchBranchesQuery = {
  'queryId': 'constants_fetchBranchesQuery_SolutionBranchUserSolutionBranch',
  'inputs': {
    'userId': '{@userId}'
  }
};
export const pageContextPayload = {
  zGenericPanelMode: 'add'
};
export const solutionDeveloperSidePanelAction = {
  name: 'openSidePanel',
  type: 'openPanel',
  pageId: 'openBranchesAddNewPanel'
};
export const solutionAdminSidePanelAction = {
  name: 'openSidePanel',
  type: 'openPanel',
  pageId: 'activeBranchAddNewSolAdminPanel'
};
export const refreshGridAction = {
  'name': 'refreshDataGrid',
  'type': 'refreshDataGrid'
};
export const LOCAL_HOST = 'localhost';
export const LAST_TWO_IN_ARRAY = -2;
export const LOCAL = 'local';
export const DEFAULT_USER_APP = 'user';
export const getDomain = () => {
  return window.location.hostname.split('.').slice(LAST_TWO_IN_ARRAY).join('.');
};
export const isDev =
  () => window.location.hostname.split('.').length === NUMBER5 ||
    window.location.hostname === LOCAL_HOST;

export const isLocal = (orgId) => orgId === LOCAL;
export const BUILDER = 'builder';
export const QUERY_BUILDER_CANVAS_TEXT = 'To start, select model(s) from the ' +
  'left panel';
export const DELETE_ACTION = 'delete';
export const DUPLICATE_ACTION = 'duplicate';
export const MAIN_PAGE_CANVAS_TEXT = 'To start drag & drop the widgets ' +
  'from the left panel';
export const SIDE_PANEL_CANVAS_TEXT = 'To start drag & drop the components ' +
  'from the left panel';
export const MAX_COMPONENT_COUNT = 9;
export const COMPONENT_MIN_WIDTH = 3;
export const COMPONENT_MIN_HEIGHT = 4;
export const DraggableItemTypes = {
  TAB: 'tab'
};
export const MAIN_PAGE_BUILDER_LEFT_MENU = [
  {
    'name': getLocalString('mod_widgets', 'Widgets'),
    'id': 'menu_0',
    'isActive': true,
    'isExpended': true,
    components: {
      'dataGrid': 'Table',
      'map': 'Map',
      'calendarWidget': 'Calendar',
      'pieChart': 'Pie Chart',
      'barChart': 'Bar Chart',
      'lineChart': 'Line Chart',
      'comboChart': 'Combo Chart',
      'bubbleChartWidget': 'Bubble Chart',
      'radarChartWidget': 'Radar Chart',
      'streamChartWidget': 'Stream Chart',
      'heatMapChartWidget': 'Heatmap Chart',
      'sunburstChartWidget': 'Sunburst Chart',
      'scatterPlotChartWidget': 'Scatterplot Chart',
      'treeMapChartWidget': 'Treemap Chart'
    }
  }
];
export const MOBILE_PAGE_BUILDER_LEFT_MENU = [
  {
    'name': getLocalString('pf_layouts', 'Layouts'),
    'id': 'menu_0',
    'isActive': false,
    'isExpended': false,
    components: {
      'jumbo': 'Jumbotron',
      'divider': 'Divider',
      'collapsibleContentBox': 'Container'
    }
  },
  {
    'name': getLocalString('basic_components', 'Basic Components'),
    'id': 'menu_1',
    'isActive': true,
    'isExpended': true,
    'components': {
      'image': 'Image',
      'input': 'Input Text',
      'textarea': 'Textrea',
      'inputdatetime': 'Date & Time',
      'inputdate': 'Date',
      'inputtime': 'Time',
      'barcode': 'Barcode/QR',
      'signaturecheck': 'Signature Check',
      'signature': 'Signature',
      'dropdown': 'Dropdown',
      'radio': 'Radio',
      'checkbox': 'Checkbox',
      'button': 'Button',
      'buttonIconarrow': 'Button Icon Arrow',
      'datagrid': 'Datagrid/Table',
      'kmzviewer': 'KMZ Viewer',
      'selectitem': 'Select Item',
      'integerinput': 'Integer Input',
      'decimalinput': 'Decimal Input',
      'multiplecomponent': 'Media Capture',
      'fileupload': 'File Upload'
    }
  },
  {
    'name': getLocalString('more', 'More'),
    'id': 'menu_2',
    'isActive': false,
    'isExpended': false,
    components: {
      'headertext': 'Header/Paragraph',
      'headerhyperlink': 'Hyperlink Header/Paragraph',
      'map': 'Map',
      'geocheckin': 'Geo Check-In',
      'mapaddress': 'Map Address',
      'document': 'Document'
    }
  }
];
export const SIDE_PANEL_BUILDER_LEFT_MENU = [
  {
    'name': getLocalString('components', 'Components'),
    'id': 'menu_0',
    'isActive': true,
    'isExpended': true,
    components: {
      'section': 'Section',
      'dataGrid': 'Data Grid',
      'input': 'Input Text',
      'textarea': 'Text Area',
      'phoneNumber': 'Phone Number',
      'address': 'Address',
      'currency': 'Text Currency',
      'numberRange': 'Number Range',
      'actionDropdown': 'Action Dropdown',
      'dropdown': 'Static Dropdown',
      'selectDropdown': 'Searchable Dropdown',
      'advancedSearch': 'Advanced Search',
      'date': 'Date Picker',
      'time': 'Time Picker',
      'datetime': 'DateTime Picker',
      'image': 'Image',
      'button': 'Button',
      'checkBox': 'Checkbox',
      'radio': 'Radio Button',
      'map': 'Map',
      'calendar': 'Calendar',
      'fileupload': 'Single File Upload',
      'player': 'Video Viewer'

    }
  }
];
export const SIDE_PANEL_COMPONENTS = {
  'section': 'Section',
  'dataGrid': 'Data Grid',
  'input': 'Input Text',
  'textarea': 'Text Area',
  'phoneNumber': 'Phone Number',
  'address': 'Address',
  'currency': 'Text Currency',
  'numberRange': 'Number Range',
  'actionDropdown': 'Action Dropdown',
  'dropdown': 'Static Dropdown',
  'selectDropdown': 'Searchable Dropdown',
  'advancedSearch': 'Advanced Search',
  'date': 'Date Picker',
  'time': 'Time Picker',
  'datetime': 'DateTime Picker',
  'image': 'Image',
  'button': 'Button',
  'checkBox': 'Checkbox',
  'radio': 'Radio Button',
  'map': 'Map',
  'calendar': 'Calendar',
  'fileupload': 'Single File Upload',
  'player': 'Video Viewer'
};
export const PAGE_COMPONENTS = {
  'dataGrid': 'Table',
  'map': 'Map',
  'calendarWidget': 'Calendar',
  'pieChart': 'Pie Chart',
  'barChart': 'Bar Chart',
  'lineChart': 'Line Chart',
  'comboChart': 'Combo Chart',
  'bubbleChartWidget': 'Bubble Chart',
  'radarChartWidget': 'Radar Chart',
  'streamChartWidget': 'Stream Chart',
  'heatMapChartWidget': 'Heatmap Chart',
  'sunburstChartWidget': 'Sunburst Chart',
  'scatterPlotChartWidget': 'Scatterplot Chart',
  'treeMapChartWidget': 'Treemap Chart'
};
export const CONVERSION_ERROR_MESSAGE = {
  'userInMaster': getLocalString('pf_user_in_master_conversion_error',
    'Conversion failed as the user is in Master. Please switch to a branch and try again.'),
  'noPageDef': getLocalString('pf_page_definition_conversion_error',
    'Conversion failed as the page definition does not exist'),
  'pageDetailError': getLocalString('pf_page_detail_conversion_error',
    'Conversion failed as the page ID or name isn’t mentioned'),
  'widgetNotFound': getLocalString('pf_widget_not_found_conversion_error',
    'Conversion failed because children for one or more components aren’t defined.'),
  'childDataError': getLocalString('pf_child_data_conversion_error',
    'Conversion failed because one or more children components aren’t configured correctly.'),
  'componentsExceedLimit': getLocalString('pf_component_limit_conversion_error',
    'Conversion failed as the number of components exceeds the allowed limit of 9.'),
  'updateFailure': getLocalString('pf_update_failure_conversion_error',
    'Conversion failed. Please check Page ID, Module Type for duplicates or mismatches.'),
  'unknownError': getLocalString('pf_unknown_conversion_error',
    'Conversion failed due to an unknown error. Please check the page definition and try again')
};
export const getIcon = (component) => {
  switch (component) {
    case 'bubbleChartWidget':
      return <img src={bubbleChart} alt={bubbleChart}
        className="Text" />;
    case 'barChart':
      return <img src={barChart} alt={barChart}
        className="Text" />;
    case 'heatMapChartWidget':
      return <img src={heatMap} alt={heatMap}
        className="Text" />;
    case 'lineChart':
      return <img src={lineChart} alt={lineChart}
        className="Text" />;
    case 'map':
      return <img src={map} alt={map}
        className="Text" />;
    case 'pieChart':
      return <img src={pieChart} alt={pieChart}
        className="Text" />;
    case 'radarChartWidget':
      return <img src={radarChart} alt={radarChart}
        className="Text" />;
    case 'scatterPlotChartWidget':
      return <img src={scatterplotChart} alt={scatterplotChart}
        className="Text" />;
    case 'streamChartWidget':
      return <img src={streamChart} alt={streamChart}
        className="Text" />;
    case 'sunburstChartWidget':
      return <img src={sunburstChart} alt={sunburstChart}
        className="Text" />;
    case 'treeMapChartWidget':
      return <img src={treemapChart} alt={treemapChart}
        className="Text" />;
    case 'comboChart':
      return <img src={comboChart} alt={comboChart}
        className="Text" />;
    case 'calendarWidget':
      return <img src={calendarChart} alt={calendarChart}
        className="Text" />;
    case 'dataGrid':
      return <img src={table} alt={table}
        className="Text" />;
    default:
      return null;
  }
};
export const getSidePanelIcon = (component) => {
  switch (component) {
    case 'section':
      return <img src={section} alt={section}
        className="Text" />;
    case 'input':
      return <img src={input} alt={input}
        className="Text" />;
    case 'dataGrid':
      return <img src={dataGrid} alt={dataGrid}
        className="Text" />;
    case 'textarea':
      return <img src={textArea} alt={textArea}
        className="Text" />;
    case 'phoneNumber':
      return <img src={phoneNumber} alt={phoneNumber}
        className="Text" />;
    case 'address':
      return <img src={address} alt={address}
        className="Text" />;
    case 'currency':
      return <img src={currency} alt={currency}
        className="Text" />;
    case 'numberRange':
      return <img src={numberRange} alt={numberRange}
        className="Text" />;
    case 'dropdown':
    case 'actionDropdown':
      return <img src={actionDropdown} alt={actionDropdown}
        className="Text" />;
    case 'selectDropdown':
      return <img src={selectDropdown} alt={selectDropdown}
        className="Text" />;
    case 'advancedSearch':
      return <img src={advancedSearch} alt={advancedSearch}
        className="Text" />;
    case 'date':
      return <img src={date} alt={date}
        className="Text" />;
    case 'time':
      return <img src={time} alt={time}
        className="Text" />;
    case 'datetime':
      return <img src={datetime} alt={datetime}
        className="Text" />;
    case 'image':
      return <img src={image} alt={image}
        className="Text" />;
    case 'button':
      return <img src={button} alt={button}
        className="Text" />;
    case 'radio':
      return <img src={radio} alt={radio}
        className="Text" />;
    case 'checkBox':
      return <img src={checkBox} alt={checkBox}
        className="Text" />;
    case 'map':
      return <img src={mapSP} alt={mapSP}
        className="Text" />;
    case 'calendar':
      return <img src={calendar} alt={calendar}
        className="Text" />;
    case 'fileUpload':
      return <img src={singleFileUpload} alt={singleFileUpload}
        className="Text" />;
    case 'player':
      return <img src={videoPlayer} alt={videoPlayer}
        className="Text" />;
    default:
      return null;
  }
};
export const getPlaceholderIcon = (component) => {
  const [, , layoutWidth, layoutHeight] = component?.layoutConfig || [];
  const placeHolderSize = (
    component.size &&
    component.size.trim().toLowerCase() === 's' && !(layoutWidth && layoutHeight
    )) ||
    layoutWidth <= COMPONENT_MIN_WIDTH ||
    layoutHeight <= COMPONENT_MIN_HEIGHT
    ? SIZE40 : SIZE72;
  switch (component?.type) {
    case 'bubbleChartWidget':
      return <img src={bubblePlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={bubblePlaceholder}
        className="Text" />;
    case 'barChart':
    case 'barChartWidget':
      return <img src={barChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={barChartPlaceholder}
        className="Text" />;
    case 'heatMapChartWidget':
      return <img src={heatMapChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={heatMapChartPlaceholder}
        className="Text" />;
    case 'lineChart':
      return <img src={lineChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={lineChartPlaceholder}
        className="Text" />;
    case 'map':
      return <img src={mapPlaceHolder} height={placeHolderSize}
        width={placeHolderSize} alt={mapPlaceHolder}
        className="Text" />;
    case 'pieChart':
    case 'pieChartWidget':
      return <img src={pieChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={pieChartPlaceholder}
        className="Text" />;
    case 'radarChartWidget':
      return <img src={radarChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={radarChartPlaceholder}
        className="Text" />;
    case 'scatterPlotChartWidget':
      return <img src={scatterplotChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={scatterplotChartPlaceholder}
        className="Text" />;
    case 'streamChartWidget':
      return <img src={streamChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={streamChartPlaceholder}
        className="Text" />;
    case 'sunburstChartWidget':
      return <img src={sunburstChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={sunburstChartPlaceholder}
        className="Text" />;
    case 'treeMapChartWidget':
      return <img src={treemapChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={treemapChartPlaceholder}
        className="Text" />;
    case 'comboChart':
      return <img src={comboChartPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={comboChartPlaceholder}
        className="Text" />;
    case 'calendarWidget':
      return <img src={calendarPlaceholder} height={placeHolderSize}
        width={placeHolderSize} alt={calendarPlaceholder}
        className="Text" />;
    case 'dataGrid':
      return <img src={tablePlaceHolder} height={placeHolderSize}
        width={placeHolderSize} alt={tablePlaceHolder}
        className="Text" />;
    default:
      return <img src={unknown} height={placeHolderSize}
        width={placeHolderSize} alt={unknown}
        className="Text" />;
  }
};
export const WPB_PLACEHOLDERS = ['id', 'title'];
export const SPB_TITLE_PLACEHOLDERS = [
  'actiondropdown', 'button', 'date',
  'time', 'datetime', 'player', 'dropdown'
];
export const TAB_TYPE = 'tab';
export const SECTION_TYPE = 'section';
export const NUMBER50 = 50;
export const NUMBER80 = 80;
export const NUMBER150 = 150;
export const NUMBER200 = 200;
export const NUMBER250 = 250;
export const NUMBER650 = 650;
export const NUMBER800 = 800;
export const NUMBER850 = 850;
export const HIGHLIGHTED_CONECTORS_COLOR = '#1413F8';
export const HIGHLIGHTED_NODE_COLOR = '#1413F8';
export const HEX3 = 0x3;
export const HEX8 = 0x8;
export const find = 'find';
export const filter = 'filter';
export const NODE_TYPES = {
  START: 'START',
  END: 'END',
  PROCESS: 'PROCESS',
  QUERY: 'QUERY',
  DECISION: 'DECISION',
  MODEL: 'MODEL',
  NETWORK: 'NETWORK',
  INSTANCE: 'INSTANCE',
  LOGGER: 'LOGGER',
  PAGE: 'PAGE',
  ZIP: 'ZIP',
  PDF: 'PDF',
  NOTIFY: 'NOTIFY',
  WORKFLOW: 'WORKFLOW',
  MULTIDECISION: 'MULTIDECISION',
  PUBLISH: 'PUBLISH',
  EXTERNAL: 'EXTERNAL',
  WHILELOOP: 'WHILELOOP',
  FOREACHLOOP: 'FOREACHLOOP',
  CSV: 'CSV',
  WSDL: 'WSDL',
  SCHEDULER: 'SCHEDULER',
  ERROR: 'ERROR',
  AI: 'AI',
  DYNAMICQUERYNODE: 'DYNAMICQUERYNODE'
};
export const GET_NODES_API_URL = 'admin/zNode/getNodes';
export const defaultSvgImage = 'https://d122pusslfmuhu.cloudfront.net/workflow-designer/Default.svg';
export const existingNodes = ['start', 'page', 'decision',
  'process', 'query', 'model', 'notify',
  'pdf', 'network', 'workflow', 'multidecision',
  'publish', 'external', 'instance', 'zip',
  'whileloop', 'foreachloop', 'logger',
  'csv', 'wsdl', 'error', 'scheduler',
  'end', 'ai'];
export const defaultNextNodeIds = ['nextNodeId',
  'nodeForTrueStep', 'nodeForFalseStep',
  'nodeIdForThisCondition'];
export const invalidMessage = 'Invalid data.\n name, nodeType,' +
  ' id value are mandatory. nodeType, id value can not be changed';
export const validMessage = 'Workflow data updated locally,' +
  ' Save in the panel to update the main workflow';
export const flowWarningMsg = 'Connector(s) already exists,' +
  'cannot add another connector to this node';
export const flowErrorMsg = 'Removed Connector. Connector(s) already exists,' +
  'cannot add another connector to this node';
export const nodesWithTwoOutgoingEdges = ['DECISION', 'WHILELOOP', 'FOREACHLOOP'];
export const DEFAULT_MULTIDECISION_CONDITION = 'condition for decision making';
export const NEXT_STEP = 'NextStep';
export const FALSE_STEP = 'FalseStep';
export const TRUE_STEP = 'TrueStep';
export const defaultStartStopDimensions = {
  width: '75px',
  height: '70px'
};
export const defaultOtherNodesDimensions = {
  width: '180px',
  height: '48px'
};
export const defaultPreviewDimensions = {
  width: '300px',
  height: '400px'
};
export const mergeTableHeaderData = [
  {
    'key': 'id',
    'name': getLocalString('pf_object_id', 'Object ID'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1.5
    }
  },
  {
    'key': 'name',
    'name': getLocalString('object_type', 'Object Type'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': true,
      'sortOrder': 'ASC',
      'flex': 1
    }
  },
  {
    'key': 'lastUpdatedAt',
    'name': getLocalString('pf_last_updated', 'Last Updated'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1.5
    }
  },
  {
    'key': 'lastUpdatedBy',
    'name': getLocalString(
      'pf_last_updated_by_user_id', 'Last Updated By User ID'
    ),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1.5
    }
  },
  {
    'key': 'objStatus',
    'name': getLocalString('pf_conflict_type', 'Conflict Type'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1
    }
  },
  {
    'key': 'status',
    'name': getLocalString('pf_merge_status', 'Merge Status'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1
    }
  }
];
export const updateTableHeaderData = [
  {
    'key': 'id',
    'name': getLocalString('pf_object_id', 'Object ID'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1.5
    }
  },
  {
    'key': 'name',
    'name': getLocalString('object_type', 'Object Type'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': true,
      'sortOrder': 'ASC',
      'flex': 1
    }
  },
  {
    'key': 'lastUpdatedAt',
    'name': getLocalString('pf_last_updated', 'Last Updated'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1.5
    }
  },
  {
    'key': 'lastUpdatedBy',
    'name': getLocalString(
      'pf_last_updated_by_user_id', 'Last Updated By User ID'
    ),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1.5
    }
  },
  {
    'key': 'status',
    'name': getLocalString('pf_merge_status', 'Merge Status'),
    'options': {
      'sortable': true,
      'showLabel': true,
      'currentSorted': false,
      'sortOrder': 'ASC',
      'flex': 1
    }
  }
];
export const reactDiffViewerStyles = {
  variables: {
    light: {
      gutterBackground: '#ffffff'
    }
  },
  gutter: {
    'max-width': '3rem',
    'border-right': '1px solid #e5e5e5',
    'border-left': '1px solid #e5e5e5'
  },
  diffContainer: {
    'pre': {
      'word-break': 'break-word',
      'white-space': 'normal',
      'font-size': '0.875rem'
    }
  }
};
export const BRANCH_SWITCH_FROM_ANOTHER_TAB = 'BRANCH_SWITCH_FROM_ANOTHER_TAB';
export const BRANCH_SWITCHER_DISABLED_ROUTES = [
  '/simulator',
  '/query-editor',
  '/models',
  '/review-changes'
];
export const BRANCH_SWITCHER_DISABLED_SIDEPANELS = [
  'workflowsPanelStudioPro',
  'rulesPanel',
  'PagesPanel',
  'queriesPanel',
  'webpagePanelStudioPro',
  'openBranchesSolAdminPanel',
  'activeBranchEditSolAdminPanel',
  'workflowDuplicatePanelStudioPro',
  'mobileAppModulesPanelStudioPro',
  'mobileAppModulesDuplicatePanel',
  'mobilePagesPanel',
  'mobileProjectsPanel',
  'mobileWorkflowsPanelStudioPro',
  'mobileWorkflowsDuplicatePanel',
  'timerEventConfigPanel',
  'processEventsPanel',
  'processEventTriggerPanel',
  'networkPanel',
  'templatesPanel',
  'znodePanel',
  'AppsPanel',
  'appsLinkPanel',
  'ModulesPanel',
  'copyWebPagePanelStudioPro',
  'widgetsPanel'
];
const defaultProperties = {
  'horizontalScroll': false,
  'verticalScroll': false,
  'colors': [],
  'errorDataImage': '/image/widgetErrorData.svg',
  'noDataImage': '/image/widgetNoData.svg'
};
export const dataGridDefault = {
  ...defaultProperties,
  'dataType': 'dynamic',
  'widgetSize': 'medium',
  'type': 'dataGrid',
  'title': 'dataGrid',
  'widgetType': 'compWidget',
  'size': 'M',
  'id': 'dataGrid',
  'jsonDef': {
    'pageContextConfig': {
      'infiniteScroll': false
    },
    'deleteAllowed': false,
    'isScrollAble': false,
    'searchAllowed': false,
    'searchEmptyScreen': {
      'image':
        'https://s3-us-west-2.amazonaws.com/' +
        'zinier-static/mastec/loc-search-cross.svg',
      'contentValue': 'SORRY! YOUR SEARCH RESULTS CAME UP EMPTY',
      'type': 'noData'
    },
    'rowActions': {},
    'emptyScreen': {
      'image':
        'https://s3-us-west-2.amazonaws.com/' +
        'zinier-static/mastec/doc-clipboard.svg',
      'contentValue': 'YOU DO NOT HAVE ANY RECORDS AVAILABLE AT THIS TIME',
      'type': 'noData'
    },
    'tableHeader': [],
    'dataToBeSent': {
      'apiResponseFormat': true
    },
    'dataSourceId': '',
    'sourceType': 'api',
    'rowTextLength': 20,
    'mainFilter': {},
    'header': {
      'filterAllowed': false,
      'subHeaderText': '',
      'headerText': '',
      'children': []
    },
    'updateAllowed': false,
    'isSelectable': false,
    'actions': [],
    'searchKeys': []
  }
};
export const implementedActions =
  ['openPanel', 'openModal', 'RefreshGridOnSidePanel'];
export const actionDefault = {
  'openModal': {
    'name': '',
    'type': 'openModal',
    'title': '',
    'subtitle': '',
    'options': [
      {
        'name': 'yes',
        'type': 'button',
        'title': '',
        'buttonType': 'primary',
        'actionOnClick': []
      },
      {
        'name': 'no',
        'type': 'button',
        'title': '',
        'buttonType': 'secondary',
        'actionOnClick': []
      }
    ]
  },
  'openPanel': {
    'name': '',
    'type': 'openPanel',
    'pageId': ''
  },
  'closePanel': {
    'name': '',
    'type': 'closePanel'
  },
  'closeModal': {
    'name': '',
    'type': 'closeModal'
  },
  'RefreshGridOnSidePanel': {
    'name': '',
    'type': 'RefreshGridOnSidePanel',
    'gridIds': []
  },
  'refreshDataGrid': {
    'name': '',
    'type': 'refreshDataGrid'
  },
  'clearPageContext': {
    'name': '',
    'type': 'clearPageContext'
  },
  'decision': {
    'name': '',
    'type': 'decision'
  },
  'query': {
    'name': '',
    'type': 'query'
  },
  'api': {
    'name': '',
    'type': 'api'
  },
  'script': {
    'name': '',
    'type': 'script'
  },
  'validatePanel': {
    'name': '',
    'type': 'validatePanel'
  },
  'showAlert': {
    'name': '',
    'type': 'showAlert'
  },
  'openOverlayView': {
    'name': '',
    'type': 'openOverlayView'
  },
  'closeOverlayView': {
    'name': '',
    'type': 'closeOverlayView'
  },
  'refreshScheduler': {
    'name': '',
    'type': 'refreshScheduler'
  },
  'refreshSearchDropdown': {
    'name': '',
    'type': 'refreshSearchDropdown'
  },
  'openModule': {
    'name': '',
    'type': 'openModule'
  },
  'startWorkflow': {
    'name': '',
    'type': 'startWorkflow'
  },
  'redirectToPage': {
    'name': '',
    'type': 'redirectToPage'
  },
  'backPanel': {
    'name': '',
    'type': 'backPanel'
  },
  'breadcrumbs': {
    'name': '',
    'type': 'breadcrumbs'
  },
  'setSync': {
    'name': '',
    'type': 'setSync'
  },
  'fetchUpdatedNotifications': {
    'name': '',
    'type': 'fetchUpdatedNotifications'
  },
  'createPDF': {
    'name': '',
    'type': 'createPDF'
  },
  'createCSV': {
    'name': '',
    'type': 'createCSV'
  },
  'saveDynamicFilter': {
    'name': '',
    'type': 'saveDynamicFilter'
  },
  'downloadFile': {
    'name': '',
    'type': 'downloadFile'
  },
  'importDataOnButtonClick': {
    'name': '',
    'type': 'importDataOnButtonClick'
  },
  'enableUIElement': {
    'name': '',
    'type': 'enableUIElement'
  },
  'disableUIElement': {
    'name': '',
    'type': 'disableUIElement'
  },
  'resetUIElement': {
    'name': '',
    'type': 'resetUIElement'
  },
  'setBranchLabel': {
    'name': '',
    'type': 'setBranchLabel'
  },
  'getBranchLabel': {
    'name': '',
    'type': 'getBranchLabel'
  },
  'validateJsonSchema': {
    'name': '',
    'type': 'validateJsonSchema'
  },
  'handleExportHidden': {
    'name': '',
    'type': 'handleExportHidden'
  },
  'setExportData': {
    'name': '',
    'type': 'setExportData'
  }
};
export const modelTypes = [
  {
    value: 'draft',
    label: getLocalString('Draft')
  },
  {
    value: 'published',
    label: getLocalString('Published')
  },
  {
    value: 'deployed',
    label: getLocalString('Deployed')
  }
];
export const DEBOUNCE_FOR_TYPE_AND_REQUEST = 500;
export const THROTTLE_FOR_TYPE_AND_REQUEST = 200;
export const DUPLICATE_IDS_ERROR = 'Duplicate IDs found across components. Each component needs to have a unique ID key. The [<oldId>,<newId>] IDs are';

export const HEADING_TEXT_FEILD = {
  'textarea': {
    'title': 'Text Area Label',
    'placeHolder': 'Text Area Placeholder'
  },
  'dropdown': {
    'title': 'Dropdown Label',
    'placeHolder': 'Dropdown Placeholder'
  },
  'input': {
    'title': 'Text Input Label',
    'placeHolder': 'Text Input Placeholder'
  },
  'mapaddress': {
    'heading': 'Address Label',
    'title': 'Address Placeholder'
  },
  'barcode': {
    'title': 'Barcode Label',
    'placeHolder': 'Barcode Placeholder'
  },
  'checkbox': {
    'heading': 'Checkbox Label',
    'title': 'Checkbox Placeholder'
  },
  'inputdatetime': {
    'title': 'Date & Time Label',
    'placeHolder': 'Date & Time Placeholder'
  },
  'inputdate': {
    'title': 'Date Label',
    'placeHolder': 'Date Placeholder'
  },
  'inputtime': {
    'title': 'Time Label',
    'placeHolder': 'Time Placeholder'
  },
  'signature': {
    'heading': 'Signature Label',
    'title': 'Signature Placeholder'
  },
  'radio': {
    'title': 'Single Selection Label'
  },
  'card': {
    'heading': 'Heading',
    'title': 'Title',
    'description': 'Description'
  },
  'fileupload': {
    'heading': 'Heading'
  },
  'photo': {
    'heading': 'Photo Box Label'
  },
  'photocomment': {
    'heading': 'Photo With Comments Label',
    'placeHolder': 'Photo With Comments Placeholder'
  },
  'photocheck': {
    'heading': 'Photo Checklist Item Label',
    'title': 'Photo Checklist Item Placeholder'
  },
  'videoinput': {
    'heading': 'Video Box Label'
  },
  'videocomment': {
    'heading': 'Video Comment Label',
    'placeHolder': 'Video Comment Placeholder'
  },
  'videoinputcheck': {
    'heading': 'Video Input Check Label',
    'title': 'Video Input Check Placeholder'
  },
  'multiplecomponent': {
    'heading': 'Multiple Component Label'
  },
  'decimalinput': {
    'title': 'Decimal Number Input Label',
    'placeHolder': 'Decimal Number Input Placeholder'
  },
  'paragraphtext': {
    'title': 'Paragraph Text Label',
    'value': 'Paragraph Text Placeholder'
  },
  'paragraphhyperlink': {
    'title': 'Paragraph Text Label',
    'value': 'Paragraph Text Placeholder'
  }
};

export const OPEN_SUB_PAGE_ACTION_NAME = '@actions.openSubpagePanel';
export const SUBCONTEXT = '@subContext';
export const PAGECONTEXT_TASKBUILDERMAP = '@pageContext.taskBuilderMap';
export const IN_PROGRESS = 'IN_PROGRESS';
export const INDEXING_STATUS_CSS = {
  PENDING: 'deactivated',
  IN_PROGRESS: 'indexing',
  COMPLETED: 'active',
  FAILED: 'failed'
};

export const BOT_STATES = {
  EDIT_BOT: 'editBot',
  ADD_BOT: 'addNewBot'
};

export const QUERY_READ = 'query/read';
export const GEN_AI_ENTITY_CONFIG = 'genAIconfig';
export const MODEL_ACCESS_ALLOWED_ENTITY_CONFIG = 'modelAccessAllowed';
export const Z_SIDEKICK_MODULE_NAME = 'ActiveZSidekickMod';
export const Z_LSS_CONFIGURATION_MODULE_NAME = 'OptimizationsMod';
export const LSS_ENTITY_CONFIG = 'lssScheduler';

export const MODELS_ERROR_MESSAGES = {
  'SES5025': getLocalString('pf_invalid_recver', 'Invalid recver passed')
};
